import React from 'react'
import { Paper, Typography } from '@material-ui/core'
import ChartDonut from '../../../../components/charts/ChartDonut'
import ChartDonutSkeleton from '../../../../components/skeletons/ChartDonutSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { formatNumber } from '../../../../utils/Helpers'

type Props = {
  totalDeliveredQuantiy: number
  multipleShoppingCartDeliveredQuantity: number

}
const ShoppingCartsQuantity = ({ totalDeliveredQuantiy, multipleShoppingCartDeliveredQuantity }: Props): JSX.Element => {
  if ((!totalDeliveredQuantiy || !multipleShoppingCartDeliveredQuantity) && (totalDeliveredQuantiy !== 0 && multipleShoppingCartDeliveredQuantity !== 0)) return <ChartDonutSkeleton />

  const labels: Array<string> = []
  const series: Array<number> = []

  labels.push('Quantidade geral')
  labels.push('Quantidade cesta simultânea')

  series.push(totalDeliveredQuantiy)
  series.push(multipleShoppingCartDeliveredQuantity)

  const options = {
    chart: {
      id: 'shopping-carts'
    },
    labels,
    yaxis: {
      show: false
    },
    fill: {
      opacity: 1
    },
    legend: {
      formatter: function (seriesName: string, opts: any) {
        return [seriesName, ' - ', formatNumber(opts.w.globals.series[opts.seriesIndex])]
      },
      width: 260,
      height: 400
    },
    dataLabels: {
      formatter: function (value: number) {
        return `${formatNumber(value, 2)}%`
      }
    },
    tooltip: {
      y: {
        formatter: (value: number) => {
          return formatNumber(value)
        }
      }
    }
  }

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Cestas simultâneas x Cestas Simples (geral) - Quantidade</Typography>
    <ChartDonut options={options} series={series} theme={ChartColumnThemes.green} type="donut" />
  </Paper>
}

export default ShoppingCartsQuantity
